import cloneDeep from 'lodash/cloneDeep'
import { createSelector } from 'reselect'

import { EMPTY_ARRAY } from 'utils/emptyConstants'

import { PLAN_TYPES } from 'containers/App/constants'
import { selectActualLicenses, selectIsFirstCampaignCreated } from 'containers/App/selectors'
import {
  createWizardCampaignSelector,
  PARTICIPANTS_ALL_CATEGORY,
  PARTICIPANTS_NAMES_CATEGORY,
} from 'containers/AwarenessCenter/constants'

import { selectParticipants, selectTriggerBasedCampaignData } from '../selectors'

const selfPath = (state) => createWizardCampaignSelector(state).setupStep

export const selectError = (state) => selfPath(state).error

// BE returns 403 {detail: "SAT is not allowed in the current plan"} from
// participants-info when the plan doesn't allow phishing simulation.
export const selectSatNotAllowedMessage = (state) => {
  const error = selectError(state)
  const rawDetail = error?.response?.detail
  return error?.status === 403 &&
    typeof rawDetail === 'string' &&
    rawDetail.startsWith('SAT is not allowed')
    ? rawDetail
    : null
}

const selectParticipantsInfo = (state) => selfPath(state).data.participantsInfoToInclude
export const selectParticipantsInfoLoader = (state) => selfPath(state).data.loader
export const selectSimulationSendingRemindersCount = (state) =>
  selfPath(state).sendingRemindersCount

export const selectParticipantsInfoToInclude = createSelector(
  selectParticipantsInfo,
  selectTriggerBasedCampaignData,
  (participantsInfo, triggerBasedCampaignData) => {
    const participantsInfoToInclude = cloneDeep(participantsInfo)

    if (triggerBasedCampaignData) {
      delete participantsInfoToInclude[PARTICIPANTS_NAMES_CATEGORY]
    }

    return participantsInfoToInclude
  }
)

export const selectParticipantsInfoToExclude = createSelector(
  selectParticipants,
  selectParticipantsInfoToInclude,
  (participants, participantsInfoToInclude) => {
    const selectedParticipants = participants.included
    const participantsToExclude = cloneDeep(participantsInfoToInclude) // deep-clone to not change original
    // options from exclude
    const categoriesToAvoid = [PARTICIPANTS_ALL_CATEGORY]
    categoriesToAvoid.forEach((i) => delete participantsToExclude[i])
    // iterate through included prticipants
    Object.keys(selectedParticipants)
      .filter((i) => !categoriesToAvoid.includes(i))
      .map((category) => {
        selectedParticipants[category].map((field) => {
          if (Array.isArray(participantsToExclude[category])) {
            // children are in array
            participantsToExclude[category] = participantsToExclude[category].filter(
              (a) => a !== field
            )
          } else if (!Array.isArray(participantsToExclude) && participantsToExclude[category]) {
            delete participantsToExclude[category][field]
          }
        })
      })

    return participantsToExclude
  }
)

export const selectQLParticipantGroups = (state) => {
  const data = selfPath(state).qlData
  if (!data.participantGroups) return EMPTY_ARRAY
  else return data.participantGroups
}
export const selectQLError = (state) => selfPath(state).qlError
export const selectQLLoader = (state) => selfPath(state).qlLoader
export const selectQLGeneratingLoader = (state) => selfPath(state).qlGeneratingLoader
export const selectQLGeneratedCampaignId = (state) => selfPath(state).qlGeneratedCampaignId
export const selectIsQuickKickoff = (state) =>
  !selectIsFirstCampaignCreated(state) && selectActualLicenses(state).plan === PLAN_TYPES.STARTER
export const selectIsLocalNotifyManagerEnabled = (state) =>
  selfPath(state).isLocalNotifyManagerEnabled
export const selectIsLocalNotifyManagerEnabledWasChanged = (state) =>
  selfPath(state).isLocalNotifyManagerEnabledWasChanged
